export const SECOND_IN_PLACEMENT_DISCOUNT = 'SecondInPlacement';
export const FLASH_SALE_DISCOUNT = 'Sale';
